import styled from 'styled-components';

interface ProfileWrapperProps {
  isSidebarOpen: boolean;
  hasInstallButton: boolean;
}

const ProfileWrapper = styled.div<ProfileWrapperProps>`
  align-items: flex-start;
  border-top: ${({ theme }) => `1px solid ${theme.palette.divider}`};
  display: flex;
  flex-direction: column;
  height: auto;
  line-height: ${({ theme }) => theme.typography.body2.lineHeight};
  overflow: hidden;
  padding: ${({ theme }) => theme.spacing(1.5)};
`;

const UserCardWrapper = styled.div`
  align-items: center;
  display: flex;
  padding-bottom: ${({ theme }) => theme.spacing(1)};
  padding-left: ${({ theme }) => theme.spacing(1.5)};
  padding-top: ${({ theme }) => theme.spacing(1)};
  width: 100%;
  &:hover,
  &:focus {
    background-color: ${({ theme }) => theme.palette.primary.lighter};
  }
`;

const UserInformationWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const UserNameWrapper = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize};
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  margin-bottom: 5px;
`;

const UserCompanyWrapper = styled.div`
  font-size: ${({ theme }) => theme.typography.fontSize};
  font-weight: ${({ theme }) => theme.typography.fontWeightMedium};
`;

export {
  ProfileWrapper,
  UserCardWrapper,
  UserInformationWrapper,
  UserNameWrapper,
  UserCompanyWrapper,
};
